import { render, staticRenderFns } from "./RepeatOrders.vue?vue&type=template&id=0f28b139"
import script from "./RepeatOrders.vue?vue&type=script&lang=js"
export * from "./RepeatOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports